export class TrainerPackage {
  constructor () {
    this.id = null
    this.trainerId = ''
    this.packageTitle = ''
    this.packageSummary = ''
    this.packageGoals = ''
    this.targetAudience = ''
    this.targetIndustry = ''
    this.duration = ''
    this.unitPrice = ''
    this.trainigType = ''
    this.keyTopics = ''
    this.keySkills = ''
    this.assessmentMethodology = ''
    this.prerequisite = ''
    this.outlineDocument = ''
  }
}



// WEBPACK FOOTER //
// ./src/models/TrainerPackage.js